var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWxTornado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86.86 89.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1",
    fill: "red"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.92,16.64h-7.4a3.15,3.15,0,0,1,0-6.3h7.4a3.15,3.15,0,0,1,0,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.74,16.64H3.15a3.15,3.15,0,0,1,0-6.3H48.74a3.15,3.15,0,0,1,0,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.27,6.3H7.94a3.15,3.15,0,0,1,0-6.3H79.27a3.15,3.15,0,1,1,0,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.81,27H48.45a3.15,3.15,0,0,1,0-6.3H62.81a3.15,3.15,0,0,1,0,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.37,27H9.85a3.15,3.15,0,0,1,0-6.3H37.37a3.15,3.15,0,1,1,0,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,37.33H36A3.15,3.15,0,1,1,36,31H70a3.15,3.15,0,1,1,0,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.69,37.33H18.58a3.15,3.15,0,1,1,0-6.3h6.11a3.15,3.15,0,1,1,0,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,47.67H32.28a3.15,3.15,0,0,1,0-6.3H79a3.15,3.15,0,1,1,0,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.71,58H79a3.15,3.15,0,0,1,0-6.3h4.73a3.15,3.15,0,1,1,0,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2,58H45.65a3.15,3.15,0,0,1,0-6.3H69.2a3.15,3.15,0,0,1,0,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.87,68.36h-10a3.15,3.15,0,0,1,0-6.3h10a3.15,3.15,0,1,1,0,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,68.36H54.43a3.15,3.15,0,1,1,0-6.3H60a3.15,3.15,0,1,1,0,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.65,78.7H48.84a3.15,3.15,0,0,1,0-6.3H65.65a3.15,3.15,0,0,1,0,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.19,89H41.5a3.15,3.15,0,1,1,0-6.3h8.69a3.15,3.15,0,0,1,0,6.3Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWxTornado);
export default __webpack_public_path__ + "static/media/wxTornado.58af0e3f2f4c94dc929731f950c1f19a.svg";
export { ForwardRef as ReactComponent };